import { render, staticRenderFns } from "./uiProgressbar.vue?vue&type=template&id=4b7870c5"
import script from "./uiProgressbar.vue?vue&type=script&lang=js"
export * from "./uiProgressbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports